import { useState } from 'react';

const PRINTER_DOWNLOADS = [
  {
    platform: 'mac',
    label: 'Mac',
    version: '1.5.1.15',
    href: 'https://dymoreleasecontent.blob.core.windows.net/dymo-release/DCDMac1.5.1.15.pkg',
  },
  {
    platform: 'windows',
    label: 'Windows',
    version: '1.5.1.20',
    href: 'https://dymoreleasecontent.blob.core.windows.net/dymo-release/DCDSetup1.5.1.20.exe',
  },
];

const SCANNER_DOWNLOADS = [
  {
    id: 'mac',
    platform: 'mac',
    label: 'Mac',
    version: '4.1.0.0',
    href: 'https://ambirfileshare.s3.us-west-2.amazonaws.com/AmbirScannerBridge-4.1.0.0.pkg',
  },
  {
    id: 'windows',
    platform: 'windows',
    label: 'Windows',
    version: '4.1.0.0',
    href: 'https://ambirfileshare.s3.us-west-2.amazonaws.com/AmbirScanWebConnect_4.1.0.0.exe',
  },
];

function currentPlatform() {
  const value = `${navigator.userAgentData?.platform || navigator.platform || ''} ${navigator.userAgent || ''}`;
  if (/win/i.test(value)) return 'windows';
  if (/mac/i.test(value)) return 'mac';
  return '';
}

function DownloadLink({ item, current }) {
  const onThisComputer = item.platform === current;
  return (
    <a className={`sa-btn sa-btn-secondary ssp-device-download ${onThisComputer ? 'current' : ''}`} href={item.href}>
      {item.label}
      <span>{item.version}</span>
    </a>
  );
}

export default function SchoolDevicesSection() {
  const current = currentPlatform();
  const [open, setOpen] = useState(false);

  return (
    <section className="sap-parents-panel ssp-devices-panel ssp-collapsible-panel">
      <button
        type="button"
        className="sap-panel-heading ssp-collapsible-heading"
        onClick={() => setOpen((currentOpen) => !currentOpen)}
        aria-expanded={open}
        aria-controls="ssp-devices-content"
      >
        <div>
          <h2>Devices</h2>
          <p>Install this software on the computer the printer or scanner is plugged into.</p>
        </div>
        <span className={`ssp-collapse-icon ${open ? 'open' : ''}`} aria-hidden="true"></span>
      </button>
      {open ? (
      <div id="ssp-devices-content" className="ssp-collapsible-content ssp-device-grid">
        <article className="ssp-device-card">
          <h3>Badge printer</h3>
          <p>DYMO Connect</p>
          <div className="ssp-device-downloads">
            {PRINTER_DOWNLOADS.map((item) => (
              <DownloadLink key={item.platform} item={item} current={current} />
            ))}
          </div>
        </article>
        <article className="ssp-device-card">
          <h3>ID scanner</h3>
          <p>AmbirScan Web Connect</p>
          <div className="ssp-device-downloads">
            {SCANNER_DOWNLOADS.map((item) => (
              <DownloadLink key={item.id} item={item} current={current} />
            ))}
          </div>
        </article>
      </div>
      ) : null}
    </section>
  );
}
